const SvgCheck = () => (
	<svg width="1em" height="1em" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1.5 7 6 10.5 15 1" stroke="#100D3D" strokeWidth={2} />
	</svg>
)

export default SvgCheck
